export class DestinationStorageKeys {
  static ADD_DESTINATION = 'destination.general.add.wizard';
}
